import * as React from 'react';
import classNames from 'classnames';
import { v4 as uuid } from 'uuid';

import Text from '../Text';
import { FontSizeProps, FontWeightProps } from '../../../@types/theme';
import styles from './Checkbox.module.scss';

// Interfaces
// //////////////////////////

export interface Props extends React.HTMLAttributes<HTMLElement> {
  name: string;
  label: string;
  description?: string;
  ellipsize?: boolean;
  value: string;
  textSize?: FontSizeProps;
  defaultTextWeight?: FontWeightProps;
  checked?: boolean;
  disabled?: boolean;
  indeterminate?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
}

/**
 * <Checkbox> component
 */
export const Checkbox: React.FunctionComponent<Props> = ({
  id,
  className,
  name,
  label,
  description,
  ellipsize = true,
  value,
  textSize = 'md',
  defaultTextWeight = 'light',
  indeterminate = false,
  checked,
  disabled,
  onChange,
  ...htmlElementProps
}) => {
  const inputId = id ?? uuid();
  return (
    <label
      htmlFor={inputId}
      className={classNames(styles.label, className, {
        disabled,
        ellipsize,
        checked,
      })}
      title={label}
      {...htmlElementProps}
    >
      <input
        id={inputId}
        type="checkbox"
        className={classNames(styles.checkbox, { indeterminate })}
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
      <div>
        <Text
          as="span"
          size={textSize}
          weight={checked ? 'bold' : defaultTextWeight}
        >
          {label}

          {description && (
            <Text size="sm2" color="gray100">
              {description}
            </Text>
          )}
        </Text>
      </div>
    </label>
  );
};

export default Checkbox;
